import { Button, Flex, Space } from "antd";
import ChevronDownIcon from "../../../../../assets/icons/ChevronDownIcon";
import { useState } from "react";
import DoubleCorrectIcon from "../../../../../assets/icons/DoubleCorrectIcon";
import Image from "../../../../../assets/images/avatar.svg";
import CoursesIcon from "../../../../../assets/icons/CoursesIcon";
import UsersIcon from "../../../../../assets/icons/UsersIcon";

export default function Overview() {
  const [expanded, setExpanded] = useState(false);
  const [expandedFeature, setExpandedFeature] = useState(false);

  const INITIAL_ROWS = 3;
  const ITEMS_PER_ROW = 2;

  const visibleCount = expandedFeature
    ? featureList.length
    : INITIAL_ROWS * ITEMS_PER_ROW;

  const visibleItems = featureList.slice(0, visibleCount);

  const leftItems = visibleItems.filter((_, i) => i % 2 === 0);
  const rightItems = visibleItems.filter((_, i) => i % 2 !== 0);

  const hasMore = featureList.length > INITIAL_ROWS * ITEMS_PER_ROW;

  return (
    <>
      <div>
        <div className="justify-start text-zinc-700 text-xl font-bold w-full border-b border-[#D7DFE9] pb-3">
          Master Figma: Getting started the Beginner to Pro Class
        </div>

        <div className="w-full border-b border-[#D7DFE9] pb-2">
          <div className="justify-start text-zinc-700 text-lg font-bold mt-3">
            Description
          </div>
          {/* Description text */}
          <div
            className={`text-slate-600 text-base font-normal leading-7 overflow-hidden 
                transition-[max-height] duration-300 ease-in-out ${
                  expanded ? "max-h-[2000px]" : "max-h-[196px]"
                }`}
          >
            You've just landed on Udemy's highest rated course on user
            experience (UX). Thousands of user researchers and designers have
            used this course to kick-start their career in UX. You can do it,
            too.
            <br />
            <br />
            Gain hands-on practice in all the key areas of UX — from
            interviewing your users through to prototyping and usability testing
            your designs.
            <br />
            <br />
            Build a UX portfolio to boost your job prospects as you complete
            five real-world sample projects.
            <br />
            <br />
            Gain industry-recognised certification by preparing for the BCS
            Foundation Certificate in User Experience.
            <br />
            <br />
            UX Mastery reviewed dozens of online courses in UX, but they gave
            just one course 10/10: this one.
            <br />
            <br />
            Build Your UX Portfolio As You Work Through 5 User Research and
            Design Projects.
            <br />
            <br />
            The sample projects in the course include:
            <br />
            <br />
            Find my pet: a product that allows people to track down wayward
            pets.
          </div>

          <Button
            type="default"
            size="middle"
            className="btn-bordered-primary border-none shadow-none !bg-transparent !text-[#EC7323] hover:!text-[#EC7323]
              hover:!border-zinc-200 focus:!border-zinc-200 active:!border-zinc-200 mt-1 p-0"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? "See Less" : "See More"}
            <ChevronDownIcon
              className={` transition-transform ${
                expanded ? "rotate-180" : ""
              }`}
            />
          </Button>
        </div>

        <div className="w-full border-b border-[#D7DFE9] pb-2">
          <div className="justify-start text-zinc-700 text-lg font-bold mt-3">
            What You’ll Learn
          </div>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
            <div className="md:col-span-6 p-4">
              {leftItems.map((item, index) => (
                <FeatureItem key={index} text={item} />
              ))}
            </div>

            <div className="md:col-span-6 p-4">
              {rightItems.map((item, index) => (
                <FeatureItem key={index} text={item} />
              ))}
            </div>
          </div>

          {hasMore && (
            <Button
              type="default"
              className="border-none shadow-none !bg-transparent !text-[#EC7323] p-0 mt-1 flex items-center gap-1"
              onClick={() => setExpandedFeature(!expandedFeature)}
            >
              {expandedFeature ? "See Less" : "See More"}
              <ChevronDownIcon
                className={`transition-transform ${
                  expandedFeature ? "rotate-180" : ""
                }`}
              />
            </Button>
          )}
        </div>

        <div className="w-full border-b border-[#D7DFE9] pb-2">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
            <div className="md:col-span-6 p-4">
              <div className="justify-start text-zinc-700 text-xl font-bold">
                Who This Course Is For
              </div>

              {courseList.map((item, index) => (
                <FeatureItem key={index} text={item} />
              ))}
            </div>

            <div className="md:col-span-6 p-4">
              <div className="justify-start text-zinc-700 text-xl font-bold">
                This Course Includes
              </div>

              {courseIncludesList.map((item, index) => (
                <FeatureItem key={index} text={item} />
              ))}
            </div>
          </div>
        </div>

        <div>
          <div className="justify-start text-zinc-700 text-xl font-bold mt-5">
            Instructor
          </div>

          <Space size={16} className="mt-5">
            <img className="w-12 h-12 rounded-full" src={Image} />
            <div>
              <div className="justify-start text-slate-600 text-lg font-medium">
                Arif Rahman
              </div>

              <div className="justify-start text-slate-600 text-sm font-normal">
                Senior UX/UI Designer
              </div>
            </div>
          </Space>

          <Flex align="center" justify="start" gap={16} className="mt-3">
            <Space size={8} align="center">
              <CoursesIcon className="text-[#455468] text-lg" />
              <div className="justify-start">
                <span className="text-zinc-700 text-sm font-medium">10</span>
                <span className="text-slate-600 text-sm font-normal">
                  {" "}
                  Courses
                </span>
              </div>
            </Space>

            <Space size={8} align="center">
              <UsersIcon className="text-[#455468] text-lg" />
              <div className="justify-start">
                <span className="text-zinc-700 text-sm font-medium">5,000</span>
                <span className="text-slate-600 text-sm font-normal">
                  {" "}
                  Learners
                </span>
              </div>
            </Space>
          </Flex>
        </div>

        <Button type="primary" size="large" className="mt-5">
          View Instructor Profile
        </Button>
      </div>
    </>
  );
}

const FeatureItem = ({ text }: { text: string }) => (
  <Space size={8} className="mt-2">
    <DoubleCorrectIcon className="text-[#5E718D] text-lg" />
    <div className="text-slate-600 text-sm font-normal">{text}</div>
  </Space>
);

const featureList = [
  "Bake UX into your workflow by following a proven, user centred design framework.",
  "Moderate a usability test and prioritise the observations.",
  "Uncover and describe users’ mental models.",
  "Plan field visits and user interviews to uncover user needs.",
  "Create personas, user stories, red routes and user journey maps.",
  "Choose appropriate schemes for classifying and organising information.",
  "Validate assumptions with real user feedback.",
  "Turn insights into actionable design decisions.",
];

const courseList = [
  "Beginners in AI tools",
  "Designers & creators",
  "Marketers & content writers",
  "Developers building AI-powered apps",
  "Anyone curious about using AI more effectively",
];

const courseIncludesList = [
  "20+ video lessons",
  "Downloadable resources",
  "Real-world examples",
  "Hands-on assignments",
  "Certificate of completion",
];
